<template>
<v-flex>
      <v-snackbar
      class="mt-5"
      v-if="localToast"
      v-model="localToast"
      :color="localToast.color"
      multi-line
      top
      right
      :timeout="localToast.timeout"
      >
        {{localToast.text}}
    </v-snackbar>
     <v-parallax
      style="width: 100vw; height:100vh;"
      height="100%"
      jumbotron
      :src="require('@/assets/Hero_Photo.jpg')"
    >
      <v-layout
        align-center
        column
        justify-center
      >
        <h1 class="display-4 font-weight-regular mb-3 mt-4" style="text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;" :style="{'padding-top': $vuetify.breakpoint.smAndDown ? '150px' : '0px'}">Tom McGee</h1>
        <h1 class="display-2 font-weight-regular mb-3" style="text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;">&</h1>
        <h1 class="display-4 font-weight-regular mb-3" style="text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;">Megan Gunn</h1>
        <v-btn
        class="hidden-sm-and-down"
        large
        primary
        @click="scrollToRSVP"
        >
          <span class="mr-2">RSVP</span>
        </v-btn>
        <h3 class="display-1 font-weight-thin mb-3 mt-5" style="text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;">October 26th, 2019 - Acquaviva Winery</h3>
      </v-layout>
    </v-parallax>
    <v-layout>
    <v-layout
      text-xs-center
      wrap
      column
    >

    <v-layout xs12 row wrap mt-2>
        <v-flex row xs12>
        <h1 class="display-2 font-weight-bold mb-3">
          Important Information
        </h1>
        </v-flex>
        <v-flex xs12 lg4 height="100%">
          <v-card color="white" class="black--text" height="100%">
            <v-card-title primary-title>
              <div>
                <v-icon large color="black">hotel</v-icon>
                <div class="headline mb-3">Lodging</div>
                <span>We invite you to join the wedding party and stay at the <a href="https://www.marriott.com/hotels/maps/travel/chisc-courtyard-chicago-st-charles/"><b>Courtyard by Marriot St. Charles</b></a> located at <b>700 Courtyard Dr, St. Charles, IL 60174</b>.<br/><br/>Midwest Coach Limousine will provide shuttles from the Marriott Hotel to Acquaviva Winery at 2:15 and 3:15 PM. Please plan accordingly as we have a large group to transport to and from the venue. Shuttles are also scheduled to return to the hotel, leaving Acquaviva at 10:15 and 11:15 PM.</span>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 lg4 height="100%">
          <v-card color="white" class="black--text" height="100%">
            <v-card-title primary-title>
              <div>
                <v-icon large color="black">favorite</v-icon>
                <div class="headline mb-3">Ceremony and Reception</div>
                <span>The ceremony and reception will both take place at <b>Acquaviva Winery</b> on <b>October 26th, 2019</b> please arrive to the winery around 3:00 PM for a shuttle ride to the vineyard ceremony! We ask that you dress <b>semi-formal</b>, and <b>refrain from using your cellphones and cameras</b> during the ceremony. When choosing your outfit, especially your shoes, keep in mind the ground in the vineyard may be soft or wet. For directions and an exact location feel free to consult <a href="https://www.google.com/maps/place/Acquaviva+Winery/@41.895576,-88.540863,17z/data=!3m1!4b1!4m5!3m4!1s0x880edf418825bd3b:0x1455488c60acf583!8m2!3d41.895572!4d-88.538669"><b>the map!</b></a></span>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 lg4 height="100%">
          <v-card color="white" class="black--text" height="100%">
            <v-card-title primary-title>
              <div class="justify-start" style="width: 100%">
                <v-icon large color="black">local_dining</v-icon>
                <div class="headline mb-3">Menu</div>
                <v-flex column class="text-xs-left">
                <p><b>Chicken</b> - Chicken Saltimbocca: Prosciutto, Provolone Cheese, Spinach, and Italian Herb Baked Breast</p>
                <p><b>Beef</b> - Filet Mignon in Acquaviva Red Wine Sauce</p>
                <p><b>Vegetarian Option</b> - Eggplant Parmesan</p>
                <p><b>Vegan Option</b> - Mushroom Risotto</p>
                <p><b>Children's Option</b> - Chicken Fingers and fries</p>
                </v-flex>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <!-- <v-flex xs12 lg4 height="100%">
          <v-card color="white" class="black--text" height="100%">
            <v-card-title primary-title>
              <div>
                <v-icon large color="black">favorite</v-icon>
                <div class="headline mb-3">Communicate Without the Code</div>
                <span>TODO Tracker's intuitive dashboard and powerful editor allows non-technical stakeholders to stay up to date on TODOs in the codebase, while still giving developers the power to store all the information they'll need to complete them.</span>
              </div>
            </v-card-title>
          </v-card>
        </v-flex> -->
    </v-layout>
    <v-layout xs12 row wrap mt-5 style="width: 100vw; max-width: 100vw">
      <v-flex row xs12>
        <v-flex xs12 lg4 style="display: inline-block;">
          <img
            contain
            style="max-height:50vh; max-width: 100vw"
            :src="require('@/assets/looking-around.jpg')"
          />
        </v-flex>
        <v-flex xs12 lg4 style="display: inline-block;">
          <img
            contain
            style="max-height:50vh; max-width: 100vw"
            :src="require('@/assets/engagement_pic.jpg')"
          />
        </v-flex>
        <v-flex xs12 lg4 style="display: inline-block;">
          <img
            contain
            style="max-height:50vh; max-width: 100vw"
            :src="require('@/assets/wooded-smile.jpg')"
          />
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout xs12 row wrap mt-5 justify-center>
        <v-flex row xs12>
        <h1 class="display-2 font-weight-bold mb-3">
          Registry
        </h1>
        </v-flex>
        <v-flex xs12 lg4 height="100%">
          <v-card color="white" class="black--text" height="100%">
            <v-card-title primary-title class="text-xs-center align-center justify-center">
              <div>
                <v-img
                  contain
                  height="100"
                  :src="require('@/assets/wanderable.png')"
                >
                </v-img>
                <div class="headline">Wanderable</div>
                <span>To give us the honeymoon of a lifetime!</span>
                <br/>
                <v-btn class="mt-3" href="https://www.wanderable.com/hm/Gunn_McGee" target="_blank">Go to Wanderable Registry</v-btn>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 lg4 height="100%">
          <v-card color="white" class="black--text" height="100%">
            <v-card-title primary-title class="text-xs-center align-center justify-center">
              <div>
                <v-img
                  contain
                  height="100"
                  :src="require('@/assets/rei_logo.jpg')"
                >
                </v-img>
                <div class="headline">REI</div>
                <span>To support our adventures!</span>
                <br/>
                <v-btn class="mt-3" href="https://www.myregistry.com/wedding-registry/Megan-Gunn-and-Tom-McGee-Chicago-IL/1872688" target="_blank">Go to REI Registry</v-btn>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 lg4 height="100%">
          <v-card color="white" class="black--text" height="100%">
            <v-card-title primary-title class="text-xs-center align-center justify-center">
              <div>
                <v-img
                  contain
                  height="100"
                  :src="require('@/assets/crate-and-barrel-logo.jpg')"
                >
                </v-img>
                <div class="headline">Crate and Barrel</div>
                <span>To help us build a home together!</span>
                <br/>
                <v-btn class="mt-3" href="https://www.crateandbarrel.com/gift-registry/megan-gunn-and-tom-mcgee/r5881350" target="_blank">Go to Crate & Barrel Registry</v-btn>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
    </v-layout>
    <v-layout xs12 row wrap mt-5 justify-center align-center class="text-xs-center" ref="rsvp">
        <v-flex row xs12 class="text-xs-center">
        <h1 class="display-2 font-weight-bold mb-3">
          RSVP
        </h1>
        </v-flex>
        <v-flex xs12 height="100%">
          <v-card color="white" class="black--text text-xs-center" height="100%" justify-center align-center>
            <v-card-title primary-title class="text-xs-center align-center justify-center">
              <v-flex xs3/>           
              <v-flex xs5 row class="text-xs-center row" justify-center align-center pb-5>
                <v-select
                  :items="[1,2,3,4,5,6,7,8,9,10]"
                  label="Number of guests"
                  v-model="numberOfGuests"
                  @change="updateNumberOfGuests"
                ></v-select>
              </v-flex>
              <v-flex xs3/>           
              <v-flex xs12 sm5 ma-2 class="text-xs-center" justify-center align-center pb-5 v-for="num in numberOfGuests" :key="num">
                <v-card class="pa-2 black--text elevation-12" style="color: black">
                  <v-icon large color="black">account_circle</v-icon>
                  <v-text-field
                    label="Full Name"
                    v-model="guests[num - 1].name"
                  ></v-text-field>
                  <v-radio-group v-model="guests[num - 1].meal" mandatory color="black" flat>
                    <v-radio style="color: black"
                      v-for="n in radioOptions"
                      :key="n.value"
                      :label="n.name"
                      :value="n.value"
                    ></v-radio>
                  </v-radio-group>
                </v-card>
              </v-flex>
              <v-flex row xs9 class="text-xs-center" justify-center align-center>
                <v-btn large block :loading="loading" color="primary" class="text-xs-center" justify-center align-center @click="RSVPGuests">RSVP!</v-btn>
              </v-flex>
            </v-card-title>
          </v-card>
        </v-flex>
    </v-layout>
    </v-layout>
  </v-layout>
  </v-flex>
</template>

<script>
import axios from "axios";
axios.defaults.baseURL = "https://todotrackerapi.azurewebsites.net/";
  export default {
    props: ['scrollToRSVP'],
    mounted: function() {
      this.get("api/Account/Heartbeat")
    },
    data: () => ({
      numberOfGuests: 1,
      guests: [{name: '', meal: ''}],
      radioGroup: 'chicken',
      loading: false,
      localToast: null,
      radioOptions: [
        {
          name: 'Chicken',
          value: 'chicken'
        },
        {
          name: 'Steak',
          value: 'steak'
        },
        {
          name: 'Vegetarian',
          value: 'vegetarian'
        },
        {
          name: 'Vegan',
          value: 'vegan'
        },
        {
          name: "Children's",
          value: 'childrens'
        },
        {
          name: "Cannot Attend",
          value: 'cannot attend'
        }
      ]
    }),
    methods: {
      get: function(uri, data = {}) {
        if (Object.keys(data).length > 0) {
          uri = `${uri}`;
        }

        return axios.get(uri, {
          headers: {},
          withCredentials: false
        });
      },
      post: function (uri, data) {
        return axios.post(uri, data, {
          headers: {'Content-Type': 'application/json'},
          withCredentials: false
        })
      },
      validRSVP: function() {
        let filteredGuests = this.guests.filter(x => { return x.name && x.meal} )
        let val = filteredGuests.length === this.numberOfGuests
        return val
      },
      RSVPGuests: function () {
        if (this.validRSVP()) {
          this.loading = true
          this.post('/api/Wedding/RSVPGuests', this.guests).then(() => {
            this.submittedForm = true
            this.localToast = {
              text: `RSVP for ${this.numberOfGuests} guest${(this.numberOfGuests > 1 ? 's' : '')} was a success! Thanks for being a part of our big day!`,
              color: "success",
              timeout: 5000
            }
            this.numberOfGuests = 1
            this.guests = [{name: '', meal: ''}]          
          }).catch( () => {
            this.localToast = {
              text: `Error processing your request, please let Tom or Megan know!`,
              color: "error",
              timeout: 5000
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.localToast = {
            text: "All guests must have a name and meal choice!",
            color: "error",
            timeout: 5000
          }
        }
      },
      updateNumberOfGuests: function () {
        for (var i = 0; i < this.numberOfGuests; i++) {
          if (!this.guests[i]) {
            this.guests[i] = {name: '', meal: ''}
          }
        }
      }
    }
  }
</script>

<style>
label.v-label.theme--light {
  color: black
}
</style>
